import {
  FaBootstrap,
  FaCss3Alt,
  FaGithub,
  FaHtml5,
  FaNpm,
  FaReact,
  FaSass,
  FaYarn,
  FaFigma,
} from 'react-icons/fa';
import { DiJavascript1 } from 'react-icons/di';
import { VscJson } from 'react-icons/vsc';
import {
  SiAdobephotoshop,
  SiJquery,
  SiTailwindcss,
  SiFirebase,
  SiStyledcomponents,
  SiFramer,
  SiRuby,
  SiRubyonrails,
  SiPostgresql,
  SiJava,
  SiKotlin,
  SiFlutter,
  SiCplusplus,
} from 'react-icons/si';

const SkillsData = [
  {
    name: 'HTML',
    icon: <FaHtml5 />,
  },
  {
    name: 'CSS',
    icon: <FaCss3Alt />,
  },
  {
    name: 'Javascript',
    icon: <DiJavascript1 />,
  },
  {
    name: 'React Js',
    icon: <FaReact />,
  },
  {
    name: 'jQuery',
    icon: <SiJquery />,
  },
  {
    name: 'Ruby',
    icon: <SiRuby />,
  },

  {
    name: 'Ruby On Rails',
    icon: <SiRubyonrails />,
  },
  {
    name: 'Java',
    icon: <SiJava />,
  },
  {
    name: 'Kotlin',
    icon: <SiKotlin />,
  },
  {
    name: 'Flutter',
    icon: <SiFlutter />,
  },
  {
    name: 'C++',
    icon: <SiCplusplus />,
  },
  {
    name: 'PostgreSql',
    icon: <SiPostgresql />,
  },
  {
    name: 'Firebase',
    icon: <SiFirebase />,
  },
  {
    name: 'JSON',
    icon: <VscJson />,
  },
  {
    name: 'Bootstrap',
    icon: <FaBootstrap />,
  },
  {
    name: 'Tailwind',
    icon: <SiTailwindcss />,
  },
  {
    name: 'Sass',
    icon: <FaSass />,
  },
  {
    name: 'Styled Components',
    icon: <SiStyledcomponents />,
  },
  {
    name: 'Framer Motion',
    icon: <SiFramer />,
  },
  {
    name: 'Git',
    icon: <FaGithub />,
  },
  {
    name: 'Npm',
    icon: <FaNpm />,
  },
  {
    name: 'Yarn',
    icon: <FaYarn />,
  },
  {
    name: 'Figma',
    icon: <FaFigma />,
  },
  {
    name: 'Photoshop',
    icon: <SiAdobephotoshop />,
  },
];

export default SkillsData;
